import { useTourStore } from '@/store/useTourStore';
import i18n from '@/i18n';
import Shepherd from 'shepherd.js';
import { TFunction } from 'i18next';

const t: TFunction = i18n.t;

const IncomeTour = new Shepherd.Tour({
  useModalOverlay: true,
  defaultStepOptions: {
    canClickTarget: false
  }
});

IncomeTour.addStep({
  id: 'add-income-step',
  text: () => t('tours.income.categories'),
  cancelIcon: {
    enabled: true
  },
  attachTo: {
    element: '.tour-category-grid',
    on: 'bottom'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: IncomeTour.next
    }
  ]
});

IncomeTour.addStep({
  id: 'income-list-step',
  text: () => t('tours.income.list'),
  canClickTarget: true,
  attachTo: {
    element: '.tour-income-list',
    on: 'top'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: IncomeTour.next
    }
  ]
})

IncomeTour.addStep({
  id: 'income-all-step',
  text: () => t('tours.income.startFromJanuary'),
  attachTo: {
    element: '.tour-category-item',
    on: 'bottom'
  },
  buttons: [
    {
      text: () => t('tours.common.ok'),
      action: IncomeTour.complete
    }
  ]
})

IncomeTour.on('complete', () => {
  useTourStore.setState({ incomeTourCompleted: true });
});

IncomeTour.on('cancel', () => {
  useTourStore.setState({ incomeTourCompleted: true });
});

export default IncomeTour
